import { Outlet } from "react-router-dom";
import { Logo } from "@/components/ui/logo";

export function AuthLayout() {
  return (
    <div className="min-h-screen bg-background">
      <div className="flex justify-center pt-10 pb-6">
        <Logo size="md" showText={true} />
      </div>
      <main className="mx-auto flex w-full max-w-md flex-col px-6">
        <Outlet />
      </main>
    </div>
  );
}
